export default "/public/img/logoLeftEn-cdd5f4f100923d92ea31a341952e877e.png";